import React from 'react';

const StepsBar = (props) => {

    const generateItems = () => {
        var elements = [];
        for(let i =0; i < props.steps; i++){
            elements.push(<li className={`stepbar__item ${i < props.currentstep ? "active" : ""}`} key={i}></li>);
        }
        return elements;
    };

    return (
        <ul className="stepbar">
            {generateItems()}
        </ul>
    );
}

export default StepsBar;
